import script from "./SelectInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectInput.vue?vue&type=script&setup=true&lang=ts"

import "./SelectInput.vue?vue&type=style&index=0&id=1cb48c8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb48c8a"]])

export default __exports__